module.exports = __webpack_public_path__ + "img/link.64cbde28.png";